module.exports = __webpack_public_path__ + "img/edit-button-remark.51ff954c.svg";